import md5 from 'md5';
import Cookies from 'universal-cookie';
import config from '../config/config'

const apiServer = config.customerAPIURL;


function makeUrl(path) {
    return `${apiServer}${path}`
}


export async function apiGet(path) {
    const token = getToken();

    return fetch(makeUrl(path), {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        if (response.status === 401) {
            clearToken();
            return {}
        }
        return response.json()
    })


}

export async function apiPost(path, data) {
    const token = getToken();
    return new Promise((resolve, reject)=>{
        fetch(makeUrl(path), {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(async (response) => {
            if (response.status === 401) {
                clearToken();
                resolve({})
            }
            const data = await response.json();
            if(response.status === 200){
                resolve(data);
            }else{
                reject(data)
            }
        })
    })
}

export async function apiPatch(path, data) {
    const token = getToken();
    return new Promise((resolve, reject)=>{
        fetch(makeUrl(path), {
            method: 'PATCH',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(async (response) => {
            if (response.status === 401) {
                clearToken();
                resolve({})
            }
            const data = await response.json();
            if(response.status === 200){
                resolve(data);
            }else{
                reject(data)
            }
        })
    })
}

export async function apiPut(path, data) {
    const token = getToken();
    return new Promise((resolve, reject)=>{
        fetch(makeUrl(path), {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(async (response) => {
            if (response.status === 401) {
                clearToken();
                resolve({})
            }
            const data = await response.json();
            if(response.status === 200){
                resolve(data);
            }else{
                reject(data)
            }
        })
    })


}

export async function apiDelete(path, data) {
    const token = getToken();

    return fetch(makeUrl(path), {
        method: 'DELETE',
        headers: {
            Authorization: 'Bearer ' + token,
            'content-type': 'application/json',
        },
        body: JSON.stringify(data)
    }).then(response => {
        if (response.status === 401) {
            clearToken();
            return {}
        }
        return response.json()
    })


}


export async function getAuthToken(username, password) {
    const body = {
        "email": username,
        "password": md5(password)
    };

    const defaultApiParams = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
    };
    
    return fetch(`${apiServer}/api/login`, {
            ...defaultApiParams,
            body: JSON.stringify(body)
        })
        .then(response => response.json())
        .then(data => {

            if (data.error) {
                alert('Failed to login : ', data.error)
                return { token: '' };
            }
            if (!data.token) {
                alert('No token in response');
                return { token: '' }
            }

            return data;
        })
}


export async function getUserList() {
    // /api/user/filter?filter[search]=anand&allResults=true
    const path = '/api/user/filter';
    return apiGet(path, )
        .then(data => {
            return data.records || [];
        })
}

export async function getFilteredUserList(filterText) {
    // /api/user/filter?filter[search]=anand&allResults=true
    const path = '/api/user/filter?filter[search]='+filterText;
    return apiGet(path,)
        .then(data => {
            return data.records || [];
        })
}

export async function getCustomerLoyaltyBalance(customerId) {
    // api/customer/loyalty/    
    const path = '/api/customer/loyalty/' + customerId;
    return apiGet(path)
        .then(data => {
            return data || [];
        })
}

export async function getCustomerLoyaltyLedger(customerId) {
    const path = '/api/customer/loyalty/filter?direction=desc&order=createdOn&limit=1000&filter[userId]=' + customerId;
    return apiGet(path)
        .then(data => {
            return data.records || [];
        })
}

export async function getCustomerProfile(customerId) {
    // Placeholder til we get profile permission
    const path = '/api/user/' + customerId;
    return apiGet(path)
        .then(data => {
            return data || {};
        })
}

export async function getCustomerActiveSubscription(customerId) {  
    const path = '/api/subscription/user/' + customerId;
    return apiGet(path)
        .then(data => {
            return data || {};
        })
}

export async function getSubscriptionLatestPayment(subId) {
    const path = '/api/subscription/latest-payment/' + subId;
    return apiGet(path)
        .then(data => {
            return data || {};
        })
   
}

export async function saveCustomerProfile(customerId, profileData) {
    // Placeholder til we get profile permission
    const path = '/api/user/' + customerId;
    return apiPatch(path, profileData)
        .then(resposedata => {
            return resposedata || {};
        })
}

export async function getCustomerInternalProfile(customerId) {
    const path = '/api/user/' + customerId + '/internal-profile';
    return apiGet(path)
        .then(data => {
            return data || {};
        })
}

export async function saveInternalProfile(customerId, profileData) {
    const path = '/api/user/' + customerId + '/internal-profile';
    return apiPut(path, profileData)
    .then(response => response || {})
}

export async function getCustomerById(customerId) {

    return {
        profile: await getCustomerProfile(customerId),
        loyaltyBalance: await getCustomerLoyaltyBalance(customerId),
        loyaltyLedger: await getCustomerLoyaltyLedger(customerId),
        milestones: await getCustomerMilestones(customerId),
        internalProfile: await getCustomerInternalProfile(customerId),
    }
}

export async function savePointsAdjustment(adjustmentRecord) {
    let path = '';
    switch (adjustmentRecord.adjustmentType) {
        case 'ADJUST_ADD':
            path = '/api/customer/loyalty';
            break;
        case 'ADJUST_REDEEM':
            path = '/api/customer/loyalty/redemption';
            break;
        default:
            console.error('Invalid redemption type');
            return Promise.reject('savePointsAdjustment : Invalid redemption type');
    }

    return apiPost(path, adjustmentRecord)
        .then((data) => {
            return data;
        })

}

export async function getCustomerCards(customerId) {  
    const path = `/api/customer/cards/${customerId}`;
    const token = getToken();

    return fetch(makeUrl(path), {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        if (response.status === 401) {
            clearToken();
            return []
        }
        if(response.status === 200){
            return response.json()
        }
        return [];
    })
}

export async function generateLoginToken(customerEmail) {
    const token = getToken();
    const data = {
        email : customerEmail
    }
    return new Promise((resolve, reject)=>{
        fetch(makeUrl('/api/generate/token'), {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data)
        }).then(async (response) => {
            if (response.status === 401) {
                clearToken();
                resolve({})
            }
            const data = await response.json();
            if(response.status === 200){
                resolve(data);
            }else{
                reject(data)
            }
        })
    })
}

export async function addCustomerCard(body) {
    const path = '/api/customer/cards';

    return apiPost(path, body)
        .then((data) => {
            return data;
        })

}

export async function deleteCustomerCard(body) {
    const path = '/api/customer/cards';

    return apiDelete(path, body)
        .then((data) => {
            return data;
        })

}
export async function getCustomerMilestones(customerId) {
    const path = '/api/customer/' + customerId + '/milestones';
    return apiGet(path)
        .then(data => {
            return data || {};
        })
}


export async function addCustomerMilestone(customerId, body) {
    const path = `/api/customer/${customerId}/milestones`;

    return apiPost(path, body)
        .then((data) => {
            return data;
        })

}

export async function eventCall() {
    const path = `/api/customer/events/experience-details/442521`;
    return apiGet(path)
    .then(result => {
        console.log({result})
    })
}

export async function getCustomerSubscriptionHistory(customerId) {
    const path = '/api/subscription/history/' + customerId;
    return apiGet(path)
        .then(data => {
            return data || {};
        })
}

const COOKIE_NAME = 'ac_uhq_token';

export function getToken() {
    const cookies = new Cookies();
    const tokenString = cookies.get(COOKIE_NAME)
    return tokenString;
};

function clearToken() {
    const cookies = new Cookies();
    cookies.remove(COOKIE_NAME);
    window.location.replace('/logout');
}

export async function getCustomersWithSubscriptions() {
    const path = '/api/subscription/users/list';
    return apiGet(path)
        .then(data => {
            return data || {};
        })
}

export async function getUserFormReponse(customerId, formCode) {
    const path = `/api/customer/${customerId}/form-response/${formCode}`;
    return apiGet(path)
        .then(data => {
            return data || {};
        })
   
}

export async function getUserUnSyncedFormReponse(customerId, formCode) {
    const path = `/api/customer/${customerId}/unsynced-form-response/${formCode}`;
    return apiGet(path)
        .then(data => {
            return data || {};
        })
   
}

export async function syncUserFormResponse(customerId, formId) {
    const path = `/api/customer/${customerId}/sync-form-response/${formId}`;

    return apiPost(path)
        .then((data) => {
            return data;
        })

}